import React from 'react';

const TestIdWrapper = ({ testId, children }: { testId?: string; children: JSX.Element }) => {
	if (testId) {
		return <div data-testid={testId}>{children}</div>;
	}
	return children;
};
export default TestIdWrapper;
